import { CollectionNameEnum } from "@finway-group/shared/lib/models"
import axios from "axios"

const MODEL = "export"

const ExportService = {
    exportChangeHistory: async (body: { resource: CollectionNameEnum; startDate: Date; endDate: Date }) => {
        const { data } = await axios.post(`/${MODEL}/change-history`, body)
        return data
    },
}

export default ExportService
